module.exports = __webpack_public_path__ + "img/OKRTree.772fc9bc.png";